import { useParams } from "react-router";
import { OrderPositionsTable } from "@/services/backend/htz/orders/components/order-positions-table";

export function PositionsRoute() {
  const { orderId } = useParams();

  return <OrderPositionsTable orderId={orderId!} />;
}
